// hooks/useCallTypes.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api"; // axios instance
// Type definitions
export interface CallType {
  service_id: number;
  call_type: string;
  service_desc: string;
}

export interface CallTypesResponse {
  statusCode: number;
  message: string;
  data: {
    services: CallType[];
  };
}

// Fetch function using api instance
const fetchCallTypes = async (): Promise<CallType[]> => {
  const response = await api.get<CallTypesResponse>("/services/v1");
  if (response.data.statusCode !== 200) {
    throw new Error(response.data.message || "Failed to fetch call types");
  }
  return response.data.data.services;
  
};

// Hook
export const useCallTypes = () => {
  return useQuery({
    queryKey: ["callTypes"],
    queryFn: fetchCallTypes,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
